import { useState } from "react";
import { useAppDispatch, useAppSelector } from "@hypexone/uicore";
import { MdEdit } from "react-icons/md";
import { MdOutlineCheckBox } from "react-icons/md";
import CheckboxComponent from "../shared/CheckboxComponent";
import {
  toggleOneClickBetting,
  useOneClickStakes,
} from "../../../utils/hooks/oneClickBetting.hooks";

const OneClickBettingStakes = () => {
  const dispatch = useAppDispatch();
  const { isOneClickBettingEnabled, oneClickBettingStakeAmount } =
    useAppSelector((state) => state.betSlip);
  const { langData } = useAppSelector((state) => state.cms);

  const { stakes, selectStake, saveStakes } = useOneClickStakes();
  const [isEditMode, setIsEditMode] = useState(false);
  const [stakesInput, setStakesInput] = useState<number[]>(stakes);

  return (
    <div className="flex flex-col gap-2 w-full text-white">
      <div className="flex items-center justify-between gap-2">
        <CheckboxComponent
          checked={isOneClickBettingEnabled}
          onChange={() =>
            toggleOneClickBetting(dispatch, !isOneClickBettingEnabled)
          }
          label={langData?.["oneClickBettingEnabled"] ?? "One Click Bet"}
        />

        {isEditMode ? (
          <MdOutlineCheckBox
            className="w-5 h-5 cursor-pointer"
            onClick={() => {
              setIsEditMode(!isEditMode);
              saveStakes(stakesInput.filter((stake) => stake > 0));
            }}
          />
        ) : (
          <MdEdit
            className="w-5 h-5 cursor-pointer"
            onClick={() => {
              setStakesInput(stakes);
              setIsEditMode(!isEditMode);
            }}
          />
        )}
      </div>

      <div className="grid grid-cols-4 items-center gap-1 w-full">
        {isEditMode
          ? stakesInput?.map((stake, index) => {
              return (
                <input
                  key={index}
                  value={stake}
                  autoFocus={index === 0}
                  onChange={(e) => {
                    const newStakes = [...stakesInput];
                    newStakes[index] = Number(e.target.value) || 0;
                    setStakesInput(newStakes);
                  }}
                  className="text-sm text-center text-black rounded-md px-1 border border-gray-300"
                />
              );
            })
          : stakes.map((stake, index) => {
              return (
                <div
                  key={index}
                  className={`text-sm text-center text-black rounded-md px-1 cursor-pointer ${
                    oneClickBettingStakeAmount === stake
                      ? "bg-black text-white"
                      : "bg-white"
                  }`}
                  onClick={() => selectStake(stake)}
                >
                  {stake}
                </div>
              );
            })}
      </div>
    </div>
  );
};

export default OneClickBettingStakes;